import script from "./ProductItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductItem.vue?vue&type=script&setup=true&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=7096e8b8&scoped=true&lang=css"

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7096e8b8"]])

export default __exports__